import * as api from '../api'
import request from '../request'

const getStationsForPlan = data => {
  return request({
    url: api.getStationsForPlan,
    method: 'POST',
    data
  })
}

const sendSmsForSign = data => {
  return request({
    url: api.sendSmsForSign,
    method: 'POST',
    data
  })
}

const saveEntrancePrintPosition = data => {
  return request({
    url: api.saveEntrancePrintPosition,
    method: 'POST',
    data
  })
}

const getEntranceTemplate = data => {
  return request({
    url: api.getEntranceTemplate,
    method: 'POST',
    data
  })
}

const getEntranceProperty = data => {
  return request({
    url: api.getEntranceProperty,
    method: 'POST',
    data
  })
}

const uploadSignTableImg = data => {
  return request({
    url: api.uploadSignTableImg,
    method: 'POST',
    data
  })
}

const getSignTableInfo = data => {
  return request({
    url: api.getSignTableInfo,
    method: 'POST',
    data
  })
}

const checkSign = data => {
  return request({
    url: api.checkSign,
    method: 'POST',
    data
  })
}

const getUnusualInfo = data => {
  return request({
    url: api.getUnusualInfo,
    method: 'POST',
    data
  })
}

const uploadUnusualImg = data => {
  return request({
    url: api.uploadUnusualImg,
    method: 'POST',
    data
  })
}

const getCustom = data => {
  return request({
    url: api.getCustom,
    method: 'POST',
    data
  })
}

const getPlaceByExamInfo = data => {
  return request({
    url: api.getPlaceByExamInfo,
    method: 'POST',
    data
  })
}

const getSystemNameFN = data => {
  return request({
    url: api.getSystemNameFN,
    method: 'POST',
    data
  })
}

const saveCustom = data => {
  return request({
    url: api.saveCustom,
    method: 'POST',
    data
  })
}

const getSystemName = data => {
  return request({
    url: api.getSystemName,
    method: 'POST',
    data
  })
}


const getConfigData = data => {
  return request({
    url: api.getConfigData,
    method: 'POST',
    data
  })
}

const addConfig = data => {
  return request({
    url: api.addConfig,
    method: 'POST',
    data
  })
}

const systemM = data => {
  return request({
    url: api.execute,
    method: 'POST',
    data
  })
}

// 获取短信系统配置
const getConfigMessageInfo = () => {
  return request({
    url: api.getConfigMessage,
    method: "POST",
  })
}

// 修改短信系统配置setConfigMessage
const setConfigMessageInfo = (data) => {
  return request({
    url: api.setConfigMessage,
    method: "POST",
    data
  })
}

// 自定义信息
const getExtDefConfigListFn = (data) => {
  return request({
    url: api.getExtDefConfigList,
    data
  })
}
const deleteExtDefConfigFn = (data) => {
  return request({
    url: api.deleteExtDefConfig,
    data
  })
}
const saveExtDefConfigListFn = (data) => {
  return request({
    url: api.saveExtDefConfigList,
    data
  })
}
const selectExtDefConfigFn = (data) => {
  return request({
    url: api.selectExtDefConfig,
    data
  })
}
const exportUserArrangement = (data) => {
  return request({
    url: api.exportUserArrangement,
    data,
    method: 'POST',
  })
}
const getCertificateInfo = (data) => {
  return request({
    url: api.getCertificateInfo,
    data,
    method: 'POST',
  })
}
const tokenListFn = (data) => {
  return request({
    url: api.tokenList,
    data
  })
}
const tokenSaveFn = (data) => {
  return request({
    url: api.tokenSave,
    data
  })
}
const getScoreListPdfFn = (data) => {
  return request({
    url: api.getScoreListPdf,
    data
  })
}
const getPlanStudentInfoFn = data => {
  return request({
    url: api.getPlanStudentInfo,
    data,
    method: 'POST'
  })
}
const getPlanStudentAskFn = data => {
  return request({
    url: api.getPlanStudentAsk,
    data,
    method: 'POST'
  })
}
const savePlanStudentAskFn = data => {
  return request({
    url: api.savePlanStudentAsk,
    data,
    method: 'POST'
  })
}
const getPhoneAndEmailConfigFn = data => {
  return request({
    url: api.getPhoneAndEmailConfig,
    data,
    method: 'POST'
  })
}
const savePhoneAndEmailConfigFn = data => {
  return request({
    url: api.savePhoneAndEmailConfig,
    data,
    method: 'POST'
  })
}

export default {
  getCertificateInfo,
  getConfigData,
  addConfig,
  systemM,
  getConfigMessageInfo,
  setConfigMessageInfo,
  getExtDefConfigListFn,
  deleteExtDefConfigFn,
  saveExtDefConfigListFn,
  selectExtDefConfigFn,
  exportUserArrangement,
  getSystemName,
  getCustom,
  saveCustom,
  getSystemNameFN,
  getPlaceByExamInfo,
  checkSign,
  getUnusualInfo,
  uploadUnusualImg,
  uploadSignTableImg,
  getSignTableInfo,
  getEntranceTemplate,
  getEntranceProperty,
  saveEntrancePrintPosition,
  getStationsForPlan,
  sendSmsForSign,
  tokenListFn,
  tokenSaveFn,
  getScoreListPdfFn,
  getPlanStudentInfoFn,
  getPlanStudentAskFn,
  savePlanStudentAskFn,
  getPhoneAndEmailConfigFn,
  savePhoneAndEmailConfigFn
}